import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { api, fileUrl } from '../lib/api';
import { PageHeader, SectionHeader, Rich, Loading, RichSection } from '../components/Shared';
import { NextStepBand } from '../components/NextStepBand';

export default function Ward8() {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/pages/ward-8').then((r) => setPage(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <Loading />;

  return (
    <div>
      <PageHeader pageKey="ward-8" kicker="OUR COMMUNITY" title={page?.title || 'Ward 8'} subtitle={page?.subtitle} image={fileUrl(page?.hero_image)} />
      <RichSection id="ward8-sections.intro" className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-8" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        {page?.sections?.filter((s) => s.published !== false).map((section) => (
          <div key={section.id} className="mb-10" data-testid="ward8-section">
            <SectionHeader kicker={section.kicker} title={section.title} />
            <Card><CardContent className="p-5 sm:p-8"><Rich html={section.body_html} /></CardContent></Card>
          </div>
        ))}
      </div>

      {/* One clear next step */}
      <NextStepBand
        title="See a problem in Ward 8? Put it on the record."
        buttonLabel="Report an Issue"
        to="/issue-tracker/report"
        secondaryLabel="Or see what neighbours have reported"
        secondaryTo="/issue-tracker"
        testId="ward8-next-step"
      />
    </div>
  );
}
